export default `
  mutation commitGitHubRepoFiles($login: String!, $owner: String!, $repo: String!, $branch: String!, $files: [GitHubCommit], $message: String!) {
    commitGitHubRepoFiles(login: $login, owner: $owner, repo: $repo, branch: $branch, files: $files, message: $message) {
      success
      resData
      errorText
    }
  }
`
